import styled from 'styled-components';

import { Card } from '../../../ToolkitV2/CardV2/Card';
import { SkeletonBlock } from '../../../ToolkitV2/Skeleton/Skeleton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.L40};
`;

const SkeletonAdCard = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  overflow: hidden;
  height: 100px;
`;

const SkeletonImage = styled(SkeletonBlock)`
  display: inline;
  padding-top: 0;
`;

const SkeletonSubmitButton = styled(SkeletonBlock)`
  float: right;
`;

export { Container, SkeletonAdCard, SkeletonImage, SkeletonSubmitButton };
